const PropTypes = require('prop-types');
const React = require('react');
const { formatText } = require('core/i18n').i18n;

const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

class BrokerFundamentalAnalysisView extends React.Component {
    constructor(props) {
        super(props);
        this.buildRadioButtons = this.buildRadioButtons.bind(this);
    }

    buildRadioButtons() {
        const filterOptions = ['filterValue', 'filterSector', 'filterDate'];
        return filterOptions.map( (id, index) => {
            let label = formatText(`broker-fundamentalAnalysis${id}`);
            return (
                <RadioButton
                    key={index}
                    className="broker-fundamental-analysis-search-view__radio"
                    label={label}
                    value={id}
                />
            );
        })
    }

    render() {
        const radioButtonsType = this.buildRadioButtons();

        return (
            <RadioButtonGroup
                name="filter-type"
                idPrefix="filter-type"
                selectedValue={this.props.selectedFilter}
                onChange={this.props.onChange}
                className="broker-fundamental-analysis-search-view__radio-group"
            >
                {radioButtonsType}
            </RadioButtonGroup>
        );
    }
}

BrokerFundamentalAnalysisView.propTypes = {
    selectedFilter: PropTypes.string,
    onChange: PropTypes.func
}

BrokerFundamentalAnalysisView.defaults = {
    onChange: function(){}
}

module.exports = BrokerFundamentalAnalysisView;